import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { Subscription, getSubscriptions } from '../../api/subscription';

type UseSubscriptionParams<T = Subscription[]> = UseQueryOptions<
  Subscription[],
  unknown,
  T,
  typeof subscriptionKeys.subscription
>;

export function useSubscriptions<T = Subscription[]>({
  select,
}: UseSubscriptionParams<T> = {}) {
  return useQuery({
    queryKey: subscriptionKeys.list(),
    queryFn: getSubscriptions,
    select: select,
  });
}

export const subscriptionKeys = {
  subscription: ['subscriptions'] as const,
  list: () => [...subscriptionKeys.subscription, 'list'] as const,
} as const;
